module.exports = __webpack_public_path__ + "img/38.0d229437.png";